"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _default = {
  "caltanissetta": {
    "168c1fde": [{
      "hkey": "40734beb",
      "slug": "caltanissetta",
      "name": "Caltanissetta",
      "primary": true,
      "skipSearch": false
    }],
    "borgata-canicasse-casale": [{
      "hkey": "40734beb",
      "slug": "caltanissetta",
      "name": "Caltanissetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "8f54ec6d": [{
      "hkey": "4a27bf0d",
      "slug": "cozzo-di-naro-prestianni-torretta",
      "name": "Cozzo di Naro-Prestianni-Torretta",
      "primary": true,
      "skipSearch": false
    }],
    "borgata-cozzo-di-naro": [{
      "hkey": "4a27bf0d",
      "slug": "cozzo-di-naro-prestianni-torretta",
      "name": "Cozzo di Naro-Prestianni-Torretta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }],
    "5ce5a04b": [{
      "hkey": "40734beb",
      "slug": "caltanissetta",
      "name": "Caltanissetta",
      "primary": true,
      "skipSearch": false
    }],
    "borgata-favarella": [{
      "hkey": "40734beb",
      "slug": "caltanissetta",
      "name": "Caltanissetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "25d64022": [{
      "hkey": "4a27bf0d",
      "slug": "cozzo-di-naro-prestianni-torretta",
      "name": "Cozzo di Naro-Prestianni-Torretta",
      "primary": true,
      "skipSearch": false
    }],
    "borgata-prestianni": [{
      "hkey": "4a27bf0d",
      "slug": "cozzo-di-naro-prestianni-torretta",
      "name": "Cozzo di Naro-Prestianni-Torretta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caltanissetta"
    }],
    "040a9d3f": [{
      "hkey": "40734beb",
      "slug": "caltanissetta",
      "name": "Caltanissetta",
      "primary": true,
      "skipSearch": false
    }],
    "borgata-santa-rita": [{
      "hkey": "40734beb",
      "slug": "caltanissetta",
      "name": "Caltanissetta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 9,
      "slugLevelParent": null
    }],
    "92ce46db": [{
      "hkey": "4a27bf0d",
      "slug": "cozzo-di-naro-prestianni-torretta",
      "name": "Cozzo di Naro-Prestianni-Torretta",
      "primary": true,
      "skipSearch": false
    }],
    "borgata-torretta": [{
      "hkey": "4a27bf0d",
      "slug": "cozzo-di-naro-prestianni-torretta",
      "name": "Cozzo di Naro-Prestianni-Torretta",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caltanissetta"
    }],
    "a2e38926": [{
      "hkey": "30c72300",
      "slug": "due-fontane-sant-elia",
      "name": "Due Fontane-Sant'Elia",
      "primary": true,
      "skipSearch": false
    }],
    "periferia": [{
      "hkey": "30c72300",
      "slug": "due-fontane-sant-elia",
      "name": "Due Fontane-Sant'Elia",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caltanissetta"
    }],
    "2321901a": [{
      "hkey": "af9b2798",
      "slug": "santa-flavia-via-filippo-paladini-via-valenti",
      "name": "Santa Flavia-Via Filippo Paladini-Via Valenti",
      "primary": true,
      "skipSearch": false
    }],
    "semicentro": [{
      "hkey": "af9b2798",
      "slug": "santa-flavia-via-filippo-paladini-via-valenti",
      "name": "Santa Flavia-Via Filippo Paladini-Via Valenti",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": "caltanissetta"
    }],
    "248378da": [{
      "hkey": "e53bd11e",
      "slug": "santo-spirito-villaggio-santa-barbara",
      "name": "Santo Spirito-Villaggio Santa Barbara",
      "primary": true,
      "skipSearch": false
    }],
    "villaggio-santa-barbara-terrapelata": [{
      "hkey": "e53bd11e",
      "slug": "santo-spirito-villaggio-santa-barbara",
      "name": "Santo Spirito-Villaggio Santa Barbara",
      "primary": true,
      "levelFrom": 10,
      "levelTo": 10,
      "slugLevelParent": null
    }]
  }
};
exports["default"] = _default;